import React, { useState, useEffect } from "react";
import "./StudentCard.css";
import logo from "./img/edaplogo.png";
import sut_icon from "./img/edaplogo.png";
import { ArrowLeft, Delete, Download } from "react-feather";
import html2canvas from "html2canvas";
import app from "./firebase";
import { getDatabase, ref, set, get, remove } from "firebase/database";

const StudentCard = ({ student, onDelete }) => {
  const handleDownload = () => {
    const card = document.querySelector(".card-box");
    html2canvas(card).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `${student.Names}.png`;
      link.click();
    });
  };

  return (

    <div>
      <div className="card-box">
        <div className="card">
          <div className="heading">
            <img src={logo} alt="University Logo" className="logo" />
            <div className="university-info">
              <h2>LISALA UNIVERSITY</h2>
              <p style={{ textAlign: "left" , textTransform: "uppercase"/* , fontWeight: "bold" */, fontSize: 13, marginBottom: 3 }}>
                interuniversity Center for pluridisciplinary research
                <br style={{marginBottom: 4}}/>
                <strong>CIREP</strong>
              </p>
            </div>
          </div>
          <div className="student-section">
            <h3>STUDENT CARD</h3>
            <div className="student-info">
              <div className="photo-container">
                <img
                  src={student.image || require("./carte etudiant/img/icon.jpg")}
                  alt={`Student ${student.Names}`}
                  className="photo"
                />
              </div>
              <div className="details">
                <p><strong>Names:</strong> {student.Names}</p>
                <p><strong>Faculty:</strong> {student.Faculty}</p>
                <p><strong>Department:</strong> {student.Department}</p>
                <p>
                  <strong>Class:</strong> {student.Class} , <strong>Matricule:</strong> {student.Matricule}
                </p>
                <p><strong>Academic Year:</strong> {student["Academic year"]}</p>
              </div>
            </div>
          </div>
          <div className="footer">
            <strong style={{ marginLeft: 50, fontSize: 11 }}>
              Web: www.cirep.ac.cd | E-mail: info@cirep.ac.ad
            </strong>
          </div>
        </div>
      </div>
        <div className="crud">
          <button className="download-button" onClick={() => onDelete(student)}>
            Supprimer <Delete style={{ margin: "1px 0 -2px 10px" }} size={15} />
          </button>
          <button className="download-button" onClick={handleDownload}>
            Telecharger <Download style={{ margin: "1px 0 -2px 10px" }} size={15} />
          </button>
        </div>
    </div>
  );
};

const Gen = () => {
  const [students, setStudents] = useState([]);
  const [formData, setFormData] = useState({
    Names: "",
    Faculty: "",
    Department: "",
    Class: "",
    Matricule: "",
    "Academic year": "",
    image: null,
  });
  const [selectedStudent, setSelectedStudent] = useState(null);

  useEffect(() => {
    const db = getDatabase(app);
    const studentsRef = ref(db, "students/");
    if (studentsRef !== ref(db,"student/ISTAM")) {
      get(studentsRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const fetchedStudents = Object.values(snapshot.val());
            setStudents(fetchedStudents);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prevData) => ({
          ...prevData,
          image: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleAddStudent = () => {
    if (
      formData.Names &&
      formData.Faculty &&
      formData.Department &&
      formData.Class &&
      formData.Matricule &&
      formData["Academic year"]
    ) {
      const newStudent = { ...formData };
      setStudents((prev) => [newStudent, ...prev]);
      const db = getDatabase(app);
      set(ref(db, `students/${formData.Matricule}`), newStudent)
        .then(() => console.log("Student data saved successfully"))
        .catch((error) => console.error("Error saving data:", error));
      setFormData({
        Names: "",
        Faculty: "",
        Department: "",
        Class: "",
        Matricule: "",
        "Academic year": "",
        image: null,
      });
    } else {
      alert("Please fill out all fields.");
    }
  };

  const handleDeleteStudent = (studentToDelete) => {
    setStudents((prev) => prev.filter((s) => s.Matricule !== studentToDelete.Matricule));
    const db = getDatabase(app);
    remove(ref(db, `students/${studentToDelete.Matricule}`))
      .then(() => console.log("Student deleted"))
      .catch((error) => console.error("Error deleting data:", error));
  };

  const handleViewStudent = (student) => {
    setSelectedStudent(student);
  };

  return (
    <div className="stu-card">
      <div className="card-form">
        <img src={logo} className="form-logo" alt="Logo" />
        <div className="card-data">
          <input
            className="cinput"
            type="text"
            name="Names"
            placeholder="Names"
            value={formData.Names}
            onChange={handleChange}
          />
          <input
            className="cinput"
            type="text"
            name="Faculty"
            placeholder="Faculty"
            value={formData.Faculty}
            onChange={handleChange}
          />
          <input
            className="cinput"
            type="text"
            name="Department"
            placeholder="Department"
            value={formData.Department}
            onChange={handleChange}
          />
          <input
            className="cinput"
            type="text"
            name="Class"
            placeholder="Class"
            value={formData.Class}
            onChange={handleChange}
          />
          <input
            className="cinput"
            type="text"
            name="Matricule"
            placeholder="Matricule"
            value={formData.Matricule}
            onChange={handleChange}
          />
          <input
            className="cinput"
            type="text"
            name="Academic year"
            placeholder="Academic Year"
            value={formData["Academic year"]}
            onChange={handleChange}
          />
          <input
            className="cinput"
            type="file"
            name="image"
            accept="image/*"
            onChange={handleChange}
          />
          <button className="download-button" onClick={handleAddStudent}>Générer la Carte</button>
        </div>
      </div>

      <div className="view-button">
        <button onClick={() => setSelectedStudent(null)}>
          {selectedStudent === null ? (
            <span></span>
          ) : (
            <span>
              <ArrowLeft size={12} /> <b> Retour </b>
            </span>
          )}
        </button>
      </div>

      {selectedStudent === null ? (
        <div>
          <h4 className="title-cards">Cartes Etudiant</h4>
          <div className="cards-container">
            {students.length === 0 ? (
              <p className="no-cards-message">Pas de carte disponible</p>
            ) : (
              students.map((student, index) => (
                <div className="card-item" key={index}>
                  <button
                    className="stu-button"
                    onClick={() => handleViewStudent(student)}
                  >
                    {student.Names}
                  </button>
                  <button
                    id="del"
                    className="crud-button"
                    onClick={() => handleDeleteStudent(student)}
                  >
                    <Delete size={18} />
                  </button>
                </div>
              ))
            )}
          </div>
        </div>
      ) : (
        <StudentCard student={selectedStudent} onDelete={handleDeleteStudent} />
      )}
    </div>
  );
};

export default Gen;
